// THE BUILD MODES THIS WEBSITE IS DEPLOYED FROM (B8, LAUNCH-COPY-B8). ONE WRITER for their names, read by the client
// (`main.tsx`) and by the build's own config (`web/deployTargets.ts`, loaded by `vite.config.ts` in Node). Pure: no
// `import.meta`, so Node can load it.
//
//   production — `npm run build`, which is `vite build` with no `--mode`: Vite's default for a build, and the build for
//                app.proppeal.com. `web/deployTargets.ts` refuses it unless every production value is set and is
//                production's, and the bundle it makes cannot run on the fake (`main.tsx`).
//   staging    — `npm run build -- --mode staging`, for staging.proppeal-app.pages.dev, from `web/.env.staging.local`.
//                Unchanged by B8: with its values missing it still falls back to the fake, saying why.
//   development — `npm run dev`, which runs on the fake unless `.env.local` says otherwise, as before.
//   test        — vitest's.
// AND NO OTHER (B8 round 2). A mode outside these four is refused by the build's config, CASE-SENSITIVELY: Vite reads any
// mode it is handed, and the verifier built `--mode Production` — not the string `production`, so ungated, on the fake,
// with a policy naming no server. `web/deployTargets.ts` `buildRefusal` holds the list.

/** Vite's name for the build that serves app.proppeal.com — and `vite build`'s default mode. */
export const PRODUCTION_MODE = "production";

/** The trial's mode (`npm run build -- --mode staging`), reading `web/.env.staging.local`. */
export const STAGING_MODE = "staging";

/** `npm run dev`'s mode (Vite's default for the dev server). */
export const DEVELOPMENT_MODE = "development";

/** Vitest's mode. */
export const TEST_MODE = "test";

/** Every mode this package builds or serves in. Any other is refused, case-sensitively (`web/deployTargets.ts`). */
export const KNOWN_MODES: readonly string[] = [PRODUCTION_MODE, STAGING_MODE, DEVELOPMENT_MODE, TEST_MODE];
